
import React from 'react';
import { RouteData } from '@/hooks/map/useRouting';

interface EtaDisplayProps {
  routeData: RouteData;
}

const EtaDisplay: React.FC<EtaDisplayProps> = ({ routeData }) => {
  return (
    <div className="absolute bottom-2 right-2 z-20 bg-white/90 p-2 rounded-md shadow-sm text-xs">
      <div className="font-medium">ETA: {routeData.etaText || `${Math.round(routeData.duration / 60)} mins`}</div>
      <div>{(routeData.distance / 1000).toFixed(1)} km</div>
    </div>
  );
};

export default EtaDisplay;
